import PopUp from "Components/PopUp";
import React, { useState } from "react"
import { Card, CardBody, CardHeader } from "reactstrap";
import VesselPositionMapStructure from "./VesselPositionMapStructure";
import { Get } from "VesselMaster/vesselMaster.hooks";
import { queryKeyes } from "shared/queryKeys";
import ErrorComponent from "Components/ErrorComponent";
import { useQuery } from "react-query";
import Skeleton from "@mui/material/Skeleton";

const VesselPositionMap = () => {
    const [popup, setPopup] = useState(false);

    /** Queries */
    /** get vessel detail for map */
    const { data: VesselDetailForMap, isLoading: VesselDetailForMapLoading, isError: VesselDetailForMapError } = useQuery(
        [queryKeyes.vessel.GetVesselDetailsForMap.key],
        async () => {
            return await Get(queryKeyes.vessel.GetVesselDetailsForMap.url());
        },
        {
            enabled: true,
        }
    );
    /** Queries end */

    return (
        <React.Fragment>
            {VesselDetailForMapLoading ? (
                <Card className="card-custom height-20">
                    <CardHeader className="p-2">
                        {/* Title placeholder */}
                        <Skeleton variant="text" width="40%" height={24} />
                    </CardHeader>
                    <CardBody className="py-0">
                        {/* Map placeholder */}
                        <Skeleton variant="rectangular" width="100%" height={250} />
                    </CardBody>
                </Card>
            ) : VesselDetailForMapError ? (
                <ErrorComponent message='Error loading required data!' />
            ) : (
                <Card className="card-custom height-20">
                    <CardHeader className="p-2">
                        <h5 className="mb-0">Vessel Position Map</h5>
                    </CardHeader>
                    <CardBody className="py-0">
                        <VesselPositionMapStructure
                            setPopup={setPopup}
                            isPopup={false}
                            imgSize={40}
                            VesselDetailForMap={VesselDetailForMap}
                        />
                    </CardBody>
                </Card>
            )}
            {popup &&
                <PopUp
                    state={popup}
                    setState={setPopup}
                    body={
                        <VesselPositionMapStructure
                            setPopup={setPopup}
                            isPopup={true}
                            imgSize={25}
                            VesselDetailForMap={VesselDetailForMap}
                        />
                    }
                    title="Vessel Position Map"
                    size="xl"
                />
            }
        </React.Fragment>
    )
}

export default VesselPositionMap;